<div class="notification-dialog" [ngClass]="type">
  <div class="dialog-icon">
    <img [alt]="type" [src]="iconSrc" />
  </div>

  <p class="dialog-title">{{ title }}</p>

  <p class="dialog-message">{{ message }}</p>

  <div class="dialog-footer">
    <button (click)="close()">Ok</button>
  </div>
</div>
